<template>
  <div>
    <attestation v-if="onAttest" :dialog="onAttest" :isAttested="isAttested" :data="attestItem" @onChange="attestConfirmation" @closed="closeConfirmation" @close="closeConfirmation"/>
    <div class="mt-5 pt-4">
      <nav class="mb-5" style="--bs-breadcrumb-divider: url(&#34;data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10'%3E%3Cpath d='M2.5 0L1 1.5 3.5 4 1 6.5 2.5 8l4-4-4-4z' fill='black'/%3E%3C/svg%3E&#34;);" aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item" style="font-size:24px; line-height: 24px; font-weight:900; color:#435666;"><strong>Training</strong></li>
          <li class="breadcrumb-item active" aria-current="page" style="font-size:24px; line-height: 24px; font-weight:300; color:#435666;">Completed Videos</li>
        </ol>
      </nav>


			<div class="mt-4">
				<div class="row">
					<div class="col-md-12">
						<div class="card shadow p-3 mb-5 bg-white rounded border-0">
							<div class="card-body">
                <div class="row mb-4">
                  <div class="col-md-6 col-xs-12">
                    <div class="d-flex flex-row ">
                      <div class="align-middle p-2 col-5" style="font-size:14px;">
                        <div class="input-group">
                          <input type="text" class="form-control" placeholder="Search training..." aria-label="Username" v-model="search" aria-describedby="search">
                        </div>
                      </div>
                      <div class="align-middle p-2 col-6">
                        <button type="button" class="btn btn-outline-primary btn-create" @click="$router.push({ name: 'AssignedTraining'})" ata-bs-placement="top">Assigned Training</button>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-xs-12">
                    <div class="d-flex flex-row-reverse">
                      <div class="align-middle p-2 col-xs-12">
                        <div class="btn-group" role="group" aria-label="Basic mixed styles example">
                          <button type="button" class="btn btn-square btn-labeled" :class="view.list ? 'btn-info text-white' : 'btn-default text-info'" :aria-pressed="view.list" @click="view.list = !view.list, view.grid = !view.list" v-tooltip.top="'Switch to List View'"><span class="btn-label"><i class="fas fa-list"></i></span></button>
                          <button type="button" class="btn btn-square btn-labeled" :class="view.grid ? 'btn-info text-white' : 'btn-default text-info'" :aria-pressed="view.grid" @click="view.grid = !view.grid, view.list = !view.grid" v-tooltip.top="'Switch to Tile View'"><span class="btn-label"><i class="fas fa-border-all"></i></span></button>
                        </div>
                      </div>
                      <div class="col-xs-12 p-3" style="font-size:14px;">
                        <div class="dropdown-toggle text-default" id="sortBy" data-bs-toggle="dropdown" aria-expanded="false">
                          <span> <strong>Sort by: </strong></span>
                          <span class="text-info" style="cursor:pointer;">{{sortBy ? sortBy.label : "Date Completed"}} </span>
                          <ul class="dropdown-menu w-25" aria-labelledby="sortBy">
                            <li><span class="dropdown-item" v-for="(item,index) in sortByOptions" :key="index" @click="sortBy = item"> {{item.label}} </span></li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div>
                  <div class="mt-5">
                    <div class="row">

                      <div v-if="loading" class="text-center align-middle">
                        <img src="@/assets/img/loading.svg">
                      </div>

                      <div v-if="completedTrainings.length == 0 && !loading" class="text-center">
                        <div class="card-body align-middle text-default" style=" margin: auto; width: 50%; padding: 100px;">
                          <h5>Completed training videos will be available here.</h5>
                        </div>
                      </div>
                      <div class="col-12 text-default ms-3" v-if="completedTrainings.length > 0 && !loading" >
                        <h2>Training Modules</h2>
                      </div>

                      <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12 mb-2" v-for="(item, index) in completedTrainings" :key="index">
                        <div class="card-body text-default" v-if="view.grid">
                          <div class="container p-0">

                          <div style="position: absolute; top: 10px; left: 10px; z-index: 2;">
                              <span class="badge border" :class="item.type === 'scorm' ? 'bg-theme text-white' : 'bg-secondary'">
                                <i :class="item.type === 'scorm' ? 'fas fa-laptop-code' : 'fas fa-play-circle'"></i>
                                {{ item.type === 'scorm' ? (item.scorm_version ? 'SCORM ' + item.scorm_version : 'SCORM') : 'Video' }}
                              </span>
                            </div>

                            <img :src="item.display_thumbnail" alt="Thumbnail" class="completed-thumbnail">

                          </div>
                          <div class="pa-0 mt-2">
                            <h6 style="font-size:14px;"><strong>{{ item.display_name}}</strong></h6>
                            <span><small class="text-muted">Completed On: </small> <small> <strong>{{ formatDate(item.display_completed) }}</strong></small></span><br/>
                            <span><small class="text-muted">Assigned On: </small> <small> <strong>{{ formatDate(item.display_assigned) }}</strong></small></span><br/>
                            <span><small class="text-muted">Result: </small> <small> <strong style="color:#00A54F;">{{ item.display_score }}</strong></small></span>
                            <br />
                            <div class="inline-block mt-1">
                              <button v-if="item.is_legacy" type="button" class="btn btn-default btn-circle" @click="downloadCertificate(item)" v-tooltip.top="'Download Certificate'" :disabled="downloadingCertificate">
                                <svg v-if="!downloadingCertificate" width="18" height="16" viewBox="0 0 21 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M16 6.996C16.7702 6.99562 17.5242 7.21761 18.1713 7.63532C18.8184 8.05302 19.3311 8.64867 19.6479 9.35071C19.9648 10.0528 20.0721 10.8313 19.9572 11.5929C19.8423 12.3545 19.5099 13.0667 19 13.644V18.244C19.0003 18.3724 18.9675 18.4987 18.905 18.6109C18.8424 18.723 18.7521 18.8172 18.6427 18.8844C18.5334 18.9517 18.4085 18.9897 18.2802 18.9949C18.1519 19.0001 18.0245 18.9722 17.91 18.914L17.82 18.859L16 17.587L14.18 18.859C14.0749 18.9324 13.9527 18.9776 13.8252 18.9904C13.6976 19.0031 13.5689 18.9829 13.4514 18.9318C13.3338 18.8806 13.2313 18.8002 13.1537 18.6982C13.0761 18.5962 13.0259 18.4759 13.008 18.349L13.001 18.244V13.642C12.4918 13.0647 12.16 12.3528 12.0454 11.5916C11.9308 10.8305 12.0382 10.0524 12.3548 9.35076C12.6714 8.64913 13.1837 8.05376 13.8303 7.63608C14.4769 7.2184 15.2302 6.99615 16 6.996ZM17.5 14.706C17.0234 14.8987 16.5141 14.9975 16 14.997C15.4859 14.9975 14.9766 14.8987 14.5 14.706V16.805L15.571 16.058C15.6806 15.9812 15.8089 15.9351 15.9423 15.9245C16.0758 15.914 16.2096 15.9393 16.33 15.998L16.43 16.058L17.5 16.805V14.706ZM17.25 3.38855e-09C17.9503 -3.47392e-05 18.6242 0.267092 19.1343 0.746893C19.6444 1.22669 19.9522 1.88302 19.995 2.582L20 2.75L20.001 7.996C19.5955 7.45609 19.0853 7.00342 18.501 6.665L18.5 2.75C18.5001 2.44054 18.3855 2.14203 18.1782 1.91223C17.971 1.68244 17.6858 1.53769 17.378 1.506L17.25 1.5H2.75C2.44054 1.49986 2.14203 1.61451 1.91223 1.82177C1.68244 2.02903 1.53769 2.31417 1.506 2.622L1.5 2.75V12.25C1.5 12.897 1.992 13.43 2.622 13.493L2.75 13.5L11.672 13.501L11.795 13.704L11.929 13.9L12 13.994L11.999 15H2.75C2.04955 15 1.37549 14.7328 0.865376 14.2527C0.35526 13.7727 0.0475365 13.1162 0.00500012 12.417L3.38855e-09 12.25V2.75C-3.47392e-05 2.04971 0.267092 1.37579 0.746893 0.865703C1.22669 0.355612 1.88302 0.0477813 2.582 0.00500012L2.75 3.38855e-09H17.25ZM16 8.496C15.3368 8.496 14.7008 8.75945 14.2319 9.22838C13.7629 9.69732 13.4995 10.3333 13.4995 10.9965C13.4995 11.6597 13.7629 12.2957 14.2319 12.7646C14.7008 13.2336 15.3368 13.497 16 13.497C16.6632 13.497 17.2992 13.2336 17.7681 12.7646C18.2371 12.2957 18.5005 11.6597 18.5005 10.9965C18.5005 10.3333 18.2371 9.69732 17.7681 9.22838C17.2992 8.75945 16.6632 8.496 16 8.496ZM9.25 9.496C9.44002 9.49606 9.62294 9.56824 9.76179 9.69797C9.90064 9.8277 9.98507 10.0053 9.99803 10.1949C10.011 10.3845 9.95148 10.5719 9.83157 10.7193C9.71165 10.8667 9.54025 10.9631 9.352 10.989L9.25 10.996H4.75C4.55998 10.9959 4.37706 10.9238 4.23821 10.794C4.09936 10.6643 4.01493 10.4867 4.00197 10.2971C3.98902 10.1075 4.04852 9.92011 4.16843 9.7727C4.28835 9.62529 4.45975 9.5289 4.648 9.503L4.75 9.496H9.25ZM15.25 3.996C15.44 3.99606 15.6229 4.06824 15.7618 4.19797C15.9006 4.3277 15.9851 4.5053 15.998 4.69488C16.011 4.88446 15.9515 5.07189 15.8316 5.2193C15.7117 5.36671 15.5402 5.4631 15.352 5.489L15.25 5.496H4.75C4.55998 5.49594 4.37706 5.42376 4.23821 5.29403C4.09936 5.1643 4.01493 4.9867 4.00197 4.79712C3.98902 4.60754 4.04852 4.42011 4.16843 4.2727C4.28835 4.12529 4.45975 4.0289 4.648 4.003L4.75 3.996H15.25Z" fill="#00A0C1"/>
                                </svg>
                                <div v-else class="spinner-border" role="status" style="height:15px; width:15px;">
                                  <span class="visually-hidden">Loading...</span>
                                </div>
                              </button>

                              <button v-if="item.is_legacy && hasPolicy" :disabled="getAttestationStatus(item) == 3" type="button" class="btn btn-default custom-icon-btn" :class="[getButtonClass(item), item.is_legacy ? 'ms-3' : '']" v-tooltip.top="getAttestationTooltip(item)" @click="setAttestation(item)">
                                <svg width="25" height="27" viewBox="0 0 25 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M20.3753 12.9048V5.4631C20.3754 5.36912 20.3566 5.27606 20.32 5.18924C20.2835 5.10242 20.2298 5.02355 20.1622 4.95714L16.3501 1.20952C16.214 1.07553 16.0293 1.00017 15.8366 1H1.72657C1.53387 1 1.34907 1.07525 1.21281 1.20921C1.07655 1.34316 1 1.52485 1 1.71429V24.0952C1 24.2847 1.07655 24.4664 1.21281 24.6003C1.34907 24.7343 1.53387 24.8095 1.72657 24.8095H11.8986M5.84383 10.5238H15.5315M5.84383 5.7619H10.6877M5.84383 15.2857H9.4767" :stroke="getSvgStrokeColor(item)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                  <path d="M15.5315 1V5.04762C15.5315 5.23706 15.608 5.41874 15.7443 5.5527C15.8805 5.68665 16.0653 5.7619 16.258 5.7619H20.3753M20.3656 16.625L23.4608 17.3976C23.7829 17.4786 24.0094 17.7667 23.9997 18.0929C23.7914 24.9476 19.7698 26 19.7698 26C19.7698 26 15.7482 24.9476 15.5399 18.0929C15.5362 17.9341 15.5875 17.7787 15.6854 17.6524C15.7834 17.526 15.9221 17.4362 16.0788 17.3976L19.174 16.625C19.5652 16.5274 19.9745 16.5274 20.3656 16.625Z" :stroke="getSvgStrokeColor(item)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                              </button>

                              <button type="button" class="btn btn-default btn-circle" :class="item.is_legacy ? 'ms-3' : ''" @click="reWatchVideo(item)" v-tooltip.top="item.type === 'scorm' ? 'Relaunch Module' : 'Rewatch Video'">
                                <i class="fas fa-redo"></i>
                              </button>

                              <button v-if="item.is_legacy" type="button" class="btn btn-default btn-circle ms-3 custom-icon-btn" ms-1 @click="downloadTakeaway(item)" v-tooltip.top="'Take away PDF'" :disabled="!item.takeaway">
                                <svg width="24" height="24" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M2.5 6.5V6H2V6.5H2.5ZM6.5 6.5V6H6V6.5H6.5ZM6.5 10.5H6V11H6.5V10.5ZM13.5 3.5H14V3.29289L13.8536 3.14645L13.5 3.5ZM10.5 0.5L10.8536 0.146447L10.7071 0H10.5V0.5ZM2.5 7H3.5V6H2.5V7ZM3 11V8.5H2V11H3ZM3 8.5V6.5H2V8.5H3ZM3.5 8H2.5V9H3.5V8ZM4 7.5C4 7.77614 3.77614 8 3.5 8V9C4.32843 9 5 8.32843 5 7.5H4ZM3.5 7C3.77614 7 4 7.22386 4 7.5H5C5 6.67157 4.32843 6 3.5 6V7ZM6 6.5V10.5H7V6.5H6ZM6.5 11H7.5V10H6.5V11ZM9 9.5V7.5H8V9.5H9ZM7.5 6H6.5V7H7.5V6ZM9 7.5C9 6.67157 8.32843 6 7.5 6V7C7.77614 7 8 7.22386 8 7.5H9ZM7.5 11C8.32843 11 9 10.3284 9 9.5H8C8 9.77614 7.77614 10 7.5 10V11ZM10 6V11H11V6H10ZM10.5 7H13V6H10.5V7ZM10.5 9H12V8H10.5V9ZM2 5V1.5H1V5H2ZM13 3.5V5H14V3.5H13ZM2.5 1H10.5V0H2.5V1ZM10.1464 0.853553L13.1464 3.85355L13.8536 3.14645L10.8536 0.146447L10.1464 0.853553ZM2 1.5C2 1.22386 2.22386 1 2.5 1V0C1.67157 0 1 0.671573 1 1.5H2ZM1 12V13.5H2V12H1ZM2.5 15H12.5V14H2.5V15ZM14 13.5V12H13V13.5H14ZM12.5 15C13.3284 15 14 14.3284 14 13.5H13C13 13.7761 12.7761 14 12.5 14V15ZM1 13.5C1 14.3284 1.67157 15 2.5 15V14C2.22386 14 2 13.7761 2 13.5H1Z" :fill="item.takeaway ? '#00a0c1' : '#435666'"/>
                                </svg>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div v-if="view.list">
                        <table class="table">
                          <thead>
                            <tr class="table-light text-default">
                              <th>Title</th>
                              <th>Assigned On</th>
                              <th>Completed On</th>
                              <th>Score / Status</th>
                              <th colspan="4">Actions</th>
                            </tr>
                          </thead>
                          <tbody class="align-middle text-default" v-for="(item, index) in completedTrainings" :key="index">
                            <tr>
                              <td style="max-width:200px;">
                                <span class="badge me-2 border" :class="item.type === 'scorm' ? 'bg-theme text-white' : 'bg-secondary'">
                                  <i :class="item.type === 'scorm' ? 'fas fa-laptop-code' : 'fas fa-play-circle'"></i>
                                  <template v-if="item.type === 'scorm'">{{ item.scorm_version ? ' SCORM ' + item.scorm_version : ' SCORM' }}</template>
                                </span>
                                {{ item.display_name }}
                              </td>
                              <td> {{ formatDate(item.display_assigned) }}</td>
                              <td>{{ formatDate(item.display_completed) }} </td>
                              <td class="text-success fw-bold">{{ item.display_score }}</td>
                              <td>
                                <button v-if="item.is_legacy" type="button" class="btn btn-default btn-circle" @click="downloadCertificate(item)" v-tooltip.top="'Download Certificate'">
                                  <svg v-if="!downloadingCertificate" width="18" height="16" viewBox="0 0 21 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M16 6.996C16.7702 6.99562 17.5242 7.21761 18.1713 7.63532C18.8184 8.05302 19.3311 8.64867 19.6479 9.35071C19.9648 10.0528 20.0721 10.8313 19.9572 11.5929C19.8423 12.3545 19.5099 13.0667 19 13.644V18.244C19.0003 18.3724 18.9675 18.4987 18.905 18.6109C18.8424 18.723 18.7521 18.8172 18.6427 18.8844C18.5334 18.9517 18.4085 18.9897 18.2802 18.9949C18.1519 19.0001 18.0245 18.9722 17.91 18.914L17.82 18.859L16 17.587L14.18 18.859C14.0749 18.9324 13.9527 18.9776 13.8252 18.9904C13.6976 19.0031 13.5689 18.9829 13.4514 18.9318C13.3338 18.8806 13.2313 18.8002 13.1537 18.6982C13.0761 18.5962 13.0259 18.4759 13.008 18.349L13.001 18.244V13.642C12.4918 13.0647 12.16 12.3528 12.0454 11.5916C11.9308 10.8305 12.0382 10.0524 12.3548 9.35076C12.6714 8.64913 13.1837 8.05376 13.8303 7.63608C14.4769 7.2184 15.2302 6.99615 16 6.996ZM17.5 14.706C17.0234 14.8987 16.5141 14.9975 16 14.997C15.4859 14.9975 14.9766 14.8987 14.5 14.706V16.805L15.571 16.058C15.6806 15.9812 15.8089 15.9351 15.9423 15.9245C16.0758 15.914 16.2096 15.9393 16.33 15.998L16.43 16.058L17.5 16.805V14.706ZM17.25 3.38855e-09C17.9503 -3.47392e-05 18.6242 0.267092 19.1343 0.746893C19.6444 1.22669 19.9522 1.88302 19.995 2.582L20 2.75L20.001 7.996C19.5955 7.45609 19.0853 7.00342 18.501 6.665L18.5 2.75C18.5001 2.44054 18.3855 2.14203 18.1782 1.91223C17.971 1.68244 17.6858 1.53769 17.378 1.506L17.25 1.5H2.75C2.44054 1.49986 2.14203 1.61451 1.91223 1.82177C1.68244 2.02903 1.53769 2.31417 1.506 2.622L1.5 2.75V12.25C1.5 12.897 1.992 13.43 2.622 13.493L2.75 13.5L11.672 13.501L11.795 13.704L11.929 13.9L12 13.994L11.999 15H2.75C2.04955 15 1.37549 14.7328 0.865376 14.2527C0.35526 13.7727 0.0475365 13.1162 0.00500012 12.417L3.38855e-09 12.25V2.75C-3.47392e-05 2.04971 0.267092 1.37579 0.746893 0.865703C1.22669 0.355612 1.88302 0.0477813 2.582 0.00500012L2.75 3.38855e-09H17.25ZM16 8.496C15.3368 8.496 14.7008 8.75945 14.2319 9.22838C13.7629 9.69732 13.4995 10.3333 13.4995 10.9965C13.4995 11.6597 13.7629 12.2957 14.2319 12.7646C14.7008 13.2336 15.3368 13.497 16 13.497C16.6632 13.497 17.2992 13.2336 17.7681 12.7646C18.2371 12.2957 18.5005 11.6597 18.5005 10.9965C18.5005 10.3333 18.2371 9.69732 17.7681 9.22838C17.2992 8.75945 16.6632 8.496 16 8.496ZM9.25 9.496C9.44002 9.49606 9.62294 9.56824 9.76179 9.69797C9.90064 9.8277 9.98507 10.0053 9.99803 10.1949C10.011 10.3845 9.95148 10.5719 9.83157 10.7193C9.71165 10.8667 9.54025 10.9631 9.352 10.989L9.25 10.996H4.75C4.55998 10.9959 4.37706 10.9238 4.23821 10.794C4.09936 10.6643 4.01493 10.4867 4.00197 10.2971C3.98902 10.1075 4.04852 9.92011 4.16843 9.7727C4.28835 9.62529 4.45975 9.5289 4.648 9.503L4.75 9.496H9.25ZM15.25 3.996C15.44 3.99606 15.6229 4.06824 15.7618 4.19797C15.9006 4.3277 15.9851 4.5053 15.998 4.69488C16.011 4.88446 15.9515 5.07189 15.8316 5.2193C15.7117 5.36671 15.5402 5.4631 15.352 5.489L15.25 5.496H4.75C4.55998 5.49594 4.37706 5.42376 4.23821 5.29403C4.09936 5.1643 4.01493 4.9867 4.00197 4.79712C3.98902 4.60754 4.04852 4.42011 4.16843 4.2727C4.28835 4.12529 4.45975 4.0289 4.648 4.003L4.75 3.996H15.25Z" fill="#00A0C1"/>
                                  </svg>
                                  <div v-else class="spinner-border" role="status" style="height:15px; width:15px;">
                                    <span class="visually-hidden">Loading...</span>
                                  </div>
                                </button>

                                <button v-if="item.is_legacy && hasPolicy" :disabled="getAttestationStatus(item) == 3" type="button" class="btn btn-default custom-icon-btn ms-2" :class="getButtonClass(item)" v-tooltip.top="getAttestationTooltip(item)" @click="setAttestation(item)">
                                  <svg width="25" height="27" viewBox="0 0 25 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M20.3753 12.9048V5.4631C20.3754 5.36912 20.3566 5.27606 20.32 5.18924C20.2835 5.10242 20.2298 5.02355 20.1622 4.95714L16.3501 1.20952C16.214 1.07553 16.0293 1.00017 15.8366 1H1.72657C1.53387 1 1.34907 1.07525 1.21281 1.20921C1.07655 1.34316 1 1.52485 1 1.71429V24.0952C1 24.2847 1.07655 24.4664 1.21281 24.6003C1.34907 24.7343 1.53387 24.8095 1.72657 24.8095H11.8986M5.84383 10.5238H15.5315M5.84383 5.7619H10.6877M5.84383 15.2857H9.4767" :stroke="getSvgStrokeColor(item)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M15.5315 1V5.04762C15.5315 5.23706 15.608 5.41874 15.7443 5.5527C15.8805 5.68665 16.0653 5.7619 16.258 5.7619H20.3753M20.3656 16.625L23.4608 17.3976C23.7829 17.4786 24.0094 17.7667 23.9997 18.0929C23.7914 24.9476 19.7698 26 19.7698 26C19.7698 26 15.7482 24.9476 15.5399 18.0929C15.5362 17.9341 15.5875 17.7787 15.6854 17.6524C15.7834 17.526 15.9221 17.4362 16.0788 17.3976L19.174 16.625C19.5652 16.5274 19.9745 16.5274 20.3656 16.625Z" :stroke="getSvgStrokeColor(item)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                </button>

                                <button type="button" class="btn btn-default btn-circle ms-2" @click="reWatchVideo(item)" v-tooltip.top="item.type === 'scorm' ? 'Relaunch Module' : 'Rewatch Video'">
                                  <i class="fas fa-redo"></i>
                                </button>

                                <button v-if="item.is_legacy && item.takeaway" type="button" class="btn btn-default btn-circle ms-2 custom-icon-btn" @click="downloadTakeaway(item)" v-tooltip.top="'Take away PDF'">
                                  <svg width="24" height="24" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M2.5 6.5V6H2V6.5H2.5ZM6.5 6.5V6H6V6.5H6.5ZM6.5 10.5H6V11H6.5V10.5ZM13.5 3.5H14V3.29289L13.8536 3.14645L13.5 3.5ZM10.5 0.5L10.8536 0.146447L10.7071 0H10.5V0.5ZM2.5 7H3.5V6H2.5V7ZM3 11V8.5H2V11H3ZM3 8.5V6.5H2V8.5H3ZM3.5 8H2.5V9H3.5V8ZM4 7.5C4 7.77614 3.77614 8 3.5 8V9C4.32843 9 5 8.32843 5 7.5H4ZM3.5 7C3.77614 7 4 7.22386 4 7.5H5C5 6.67157 4.32843 6 3.5 6V7ZM6 6.5V10.5H7V6.5H6ZM6.5 11H7.5V10H6.5V11ZM9 9.5V7.5H8V9.5H9ZM7.5 6H6.5V7H7.5V6ZM9 7.5C9 6.67157 8.32843 6 7.5 6V7C7.77614 7 8 7.22386 8 7.5H9ZM7.5 11C8.32843 11 9 10.3284 9 9.5H8C8 9.77614 7.77614 10 7.5 10V11ZM10 6V11H11V6H10ZM10.5 7H13V6H10.5V7ZM10.5 9H12V8H10.5V9ZM2 5V1.5H1V5H2ZM13 3.5V5H14V3.5H13ZM2.5 1H10.5V0H2.5V1ZM10.1464 0.853553L13.1464 3.85355L13.8536 3.14645L10.8536 0.146447L10.1464 0.853553ZM2 1.5C2 1.22386 2.22386 1 2.5 1V0C1.67157 0 1 0.671573 1 1.5H2ZM1 12V13.5H2V12H1ZM2.5 15H12.5V14H2.5V15ZM14 13.5V12H13V13.5H14ZM12.5 15C13.3284 15 14 14.3284 14 13.5H13C13 13.7761 12.7761 14 12.5 14V15ZM1 13.5C1 14.3284 1.67157 15 2.5 15V14C2.22386 14 2 13.7761 2 13.5H1Z" :fill="item.takeaway ? '#00a0c1' : '#435666'"/>
                                  </svg>
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                    </div>
                  </div>
                </div>

							</div>
						</div>
					</div>
				</div>
			</div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { debounce } from '@/plugins/helper.js'
import Attestation from '@/components/policies/Attestation.vue';


export default {
  name: "CompletedTraining",

  components: {
     Attestation
   },

  data() {
    return {
      loading: false,
      downloadingCertificate: false,
      completedTrainings: [],
      isAttested: false,
      search: '',
      view: {
        list: false,
        grid: true,
      },

      sortBy: {label: "Date Completed", value: "date_completed"},
      sortByOptions:[
        {
          label: "Date Completed",
          value: "date_completed"
        },
        {
          label: "Grade",
          value: "grade"
        },
      ],
      organisationID: 0,
      onAttest: false,
      attestItem: null,
      orgFeatures: [],
    }
  },

  computed: {
    hasPolicy() {
      // Check if the user's organization has the policy product
      return this.$store.state.auth.hasPolicy;
    }
  },

  async created() {
    if (this.$helper.isVertexAnalyst()) {
      let analystOrg = null;
      try {
        const organisationString = localStorage.getItem('userOrganisation');
        analystOrg = organisationString ? JSON.parse(organisationString) : null;
      } catch (e) {
        analystOrg = null;
      }
      this.organisationID = analystOrg?.id || this.$store.state.auth.jwtPayload?.organisation_role?.[0]?.organisation_id || this.$helper.setOrganisationID();
    } else {
      this.organisationID = this.$helper.setOrganisationID() || this.$store.state.user.organisation?.organisation_id || this.$store.state.user.organisation?.id;
    }

    await this.getOrganisationFeatures();
    await this.getData();
  },


  methods: {
    async getData() {
      this.loading = true;
      const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      let params = { filter: this.search, sort: this.sortBy ? this.sortBy.value : '', timezone: userTimeZone };
      let userID = this.$store.state.auth.jwtPayload.user_id;

      let mergedCompleted = [];
      let knownShadowIds = []; // Track EXACT shadow IDs

      try {
        let userQuizResults = [];
        try {
          const quizRes = await this.$axios.get(`/trainings/users/${userID}/answers`);
          if (quizRes.data.success) {
            userQuizResults = quizRes.data.quiz_results || [];
          }
        } catch (e) {
          console.warn("Failed to fetch quiz results", e);
        }

        // 1. FETCH NEW LMS COMPLETED MODULES FIRST (To build the Deduplication List)
        if (!this.$store.state.auth.isSuperAdmin) {
          const newRes = await this.$axios.get(`/trainings/users/${userID}/organisations/${this.organisationID}/dashboard`);

          if (newRes.data.success) {

           // Helper function to process any assignment (Enrollment or Ad-Hoc)
            const processAssignment = (assignment) => {
                const status = assignment.status || assignment.Status;

                if (status === 'completed') {
                  const mod = assignment.training_module || assignment.TrainingModule;
                  if (!mod) return;
                  if (mod.is_active === false || mod.IsActive === false) return;

                  const isDefault = mod.is_default_video || mod.IsDefaultVideo || mod.is_vertex_default || mod.IsVertexDefault || false;

                  if (isDefault) return;

                  // Basic frontend search filter
                  if (this.search && !mod.name.toLowerCase().includes(this.search.toLowerCase())) return;

                  const actualVideoId = mod.legacy_video_id || mod.LegacyVideoID || mod.ID || mod.id;
                  const type = (mod.type || mod.Type || 'video').toLowerCase();
                  const scormVer = mod.scorm_version || mod.ScormVersion || '';

                  // Record the exact legacy shadow ID so we can hide it later
                  const shadowId = assignment.legacy_assignment_id || assignment.LegacyAssignmentID;
                  if (shadowId) knownShadowIds.push(shadowId);

                  const scormData = assignment.scorm_data || assignment.ScormData;
                  let displayScore = 'Complete';
                  let rawScore = 100;

                  if (type === 'scorm' && scormData) {
                    displayScore = scormData.score + '%';
                    rawScore = scormData.score;
                  } else if (type === 'video') {
                    const assignmentId = assignment.ID || assignment.id;
                    const quizAttempt = userQuizResults.find(q =>
                      (q.user_assignment_id === assignmentId || q.UserAssignmentID === assignmentId) &&
                      (q.is_passed === true || q.IsPassed === true)
                    );

                    if (quizAttempt) {
                       const grade = quizAttempt.grade !== undefined ? quizAttempt.grade : quizAttempt.Grade;
                       displayScore = grade + '%';
                       rawScore = grade;
                    }
                  }

                  const defaultThumb = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 800 450' width='100%25' height='100%25'%3E%3Crect width='800' height='450' fill='%230f172a'/%3E%3Crect width='800' height='6' fill='%2300a0c1'/%3E%3Cg stroke='rgba(255,255,255,0.03)' stroke-width='1'%3E%3Cline x1='0' y1='75' x2='800' y2='75' /%3E%3Cline x1='0' y1='150' x2='800' y2='150' /%3E%3Cline x1='0' y1='225' x2='800' y2='225' /%3E%3Cline x1='0' y1='300' x2='800' y2='300' /%3E%3Cline x1='0' y1='375' x2='800' y2='375' /%3E%3Cline x1='200' y1='0' x2='200' y2='450' /%3E%3Cline x1='400' y1='0' x2='400' y2='450' /%3E%3Cline x1='600' y1='0' x2='600' y2='450' /%3E%3C/g%3E%3Ccircle cx='400' cy='215' r='65' fill='rgba(0, 160, 193, 0.1)' stroke='%2300a0c1' stroke-width='4'/%3E%3Cpolygon points='385,185 385,245 435,215' fill='%2300a0c1'/%3E%3Ctext x='400' y='330' font-family='-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif' font-size='22' font-weight='700' fill='%2364748b' text-anchor='middle' letter-spacing='3'%3ETRAINING MODULE%3C/text%3E%3C/svg%3E";

                  let fetchedThumb = mod.thumbnail || mod.Thumbnail;
                  let finalThumb = (fetchedThumb && fetchedThumb.trim() !== '') ? fetchedThumb : defaultThumb;

                  mergedCompleted.push({
                    is_legacy: isDefault,
                    type: type,
                    scorm_version: scormVer,
                    video_id: actualVideoId,
                    assigned_user_video_id: assignment.ID || assignment.id,
                    display_name: mod.name || mod.Name,
                    display_thumbnail: finalThumb,
                    display_assigned: assignment.CreatedAt || assignment.created_at,
                    display_completed: assignment.UpdatedAt || assignment.updated_at,
                    display_score: displayScore,
                    grade: rawScore,
                    takeaway: null,
                    training_policies: []
                  });
                }
            };

            if (newRes.data.enrollments) {
              newRes.data.enrollments.forEach(enrollment => {
                (enrollment.module_assignments || enrollment.ModuleAssignments || []).forEach(processAssignment);
              });
            }

            const adhocList = newRes.data.adhoc_assignments || newRes.data.module_assignments || newRes.data.standalone_assignments || [];
            adhocList.forEach(processAssignment);
          }
        }

        // 2. FETCH LEGACY COMPLETED VIDEOS (And hide exact duplicates)
        const legacyRes = await this.$axios.get(`/trainings/users/${userID}/organisations/${this.organisationID}/completed-trainings`, { params });
        if (legacyRes.data.success && legacyRes.data.completed_trainings) {
          legacyRes.data.completed_trainings.forEach(v => {

            // Hide ONLY the exact shadow assignment created by the LMS program!
            if (knownShadowIds.includes(v.assigned_user_video_id)) return;

            mergedCompleted.push({
              is_legacy: true,
              type: 'video',
              video_id: v.video_id,
              assigned_user_video_id: v.assigned_user_video_id,
              display_name: v.name,
              display_thumbnail: v.thumbnail,
              display_assigned: v.date_assigned,
              display_completed: v.quiz_finished,
              display_score: v.grade + '%',
              grade: v.grade,
              takeaway: v.takeaway,
              training_policies: v.training_policies || []
            });
          });
        }

        // 3. Sort the combined array by completion date
        if (this.sortBy && this.sortBy.value === 'date_completed') {
           mergedCompleted.sort((a, b) => new Date(b.display_completed) - new Date(a.display_completed));
        }

        this.completedTrainings = mergedCompleted;

      } catch (error) {
        this.$toast.error("Failed to load completed trainings.");
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    getOrganisationFeatures() {
      this.$axios.get('/organisation-feature/user/'+ this.$store.state.auth.jwtPayload.user_id+'/organisations/'+this.$helper.setOrganisationID())
      .then((response) => {
          if (response.data.success){
              this.orgFeatures = response.data.org_features
          } else {
            this.$toast.error(response.data.message)
          }
      })
      .catch()
    },

    formatDate(value){
      return moment(value).format("LL")
    },

    reWatchVideo(item){
      this.$router.push({
        path: '/training/assigned-training',
        query: {
            rewatch: item.video_id,
            assigned: item.assigned_user_video_id,
            autoplay: true,
            finished: item.display_completed,
            is_legacy: item.is_legacy,
            type: item.type
        }
      });

    },
    async downloadCertificate(item) {
      this.downloadingCertificate = true;
      let analystOrg = null;
      if (this.$helper.isVertexAnalyst()) {
        try {
          const organisationString = localStorage.getItem('userOrganisation');
          analystOrg = organisationString ? JSON.parse(organisationString) : null;
        } catch (e) {
          analystOrg = null;
        }
      }

      const orgName = this.$helper.isVertexAnalyst()
        ? (analystOrg?.name || this.$store.state.auth.jwtPayload?.organisation_role?.[0]?.organisation || this.$store.state.user.organisation?.name || 'Organisation')
        : (this.$store.state.user.organisation?.organisation || this.$store.state.user.organisation?.name || '');

      let data = {
        training_video_id:  item.video_id,
        score:              item.grade,
        first_name:         this.$store.state.auth.jwtPayload.first_name,
        last_name:          this.$store.state.auth.jwtPayload.last_name,
        organisation:       orgName,
        date_completed:     moment(item.quiz_finished).local().format()
      }

      await this.$axios.post('/trainings/users/'+this.$store.state.auth.jwtPayload.user_id+'/completion-pdf', data)
      .then((response) => {
          if (response.data.success){
            var pdf = this.base64ToArrayBuffer(response.data.pdf);
            this.saveByteArray("Training Certificate", pdf);
          } else {
            this.$toast.error(response.data.message)
          }
      })
      .catch()

      this.downloadingCertificate = false
    },

    base64ToArrayBuffer(base64) {
      var binaryString = window.atob(base64);
      var binaryLen = binaryString.length;
      var bytes = new Uint8Array(binaryLen);
      for (var i = 0; i < binaryLen; i++) {
      var ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
      }
      return bytes;
    },

    saveByteArray(reportName, byte) {
      var blob = new Blob([byte], {type: "application/pdf"});
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      var fileName = reportName;
      link.download = fileName;
      link.click();
    },

    downloadTakeaway(item) {
      if (!item.takeaway) {
        this.$toast.error("Takeaway link not available for this training topic.");
      } else {
        // Extract the filename from the item.takeaway URL
        const urlParts = item.takeaway.split("/");
        const filename = urlParts[urlParts.length - 1];

        // Create a temporary anchor element
        const link = document.createElement("a");
        link.href = item.takeaway;
        link.target = "_blank"; // Optional: Open the link in a new tab
        link.download = filename; // Set the filename for the downloaded PDF
        link.click();
      }
    },

    setAttestation(item) {
        // If the organization doesn't have the policy product, do nothing.
        if (!this.hasPolicy || !item.training_policies || item.training_policies.length === 0) {
            return;
        }

        const requiredPolicies = item.training_policies.filter(policy => policy.required);
        const attestedPolicies = item.training_policies.filter(policy => policy.attested && policy.attested.attested);

        // If no policies are required, but the user has already attested to some, display them
        if (requiredPolicies.length === 0) {
            if (attestedPolicies.length > 0) {
                this.attestItem = item.training_policies;
                this.isAttested = true;
                this.onAttest = true;
            }
            return;
        }

        // Check if all required policies have been attested by the user
        const allRequiredPoliciesAttested = requiredPolicies.every(policy => policy.attested && policy.attested.attested);

        if (allRequiredPoliciesAttested) {
          this.attestItem = item.training_policies;
          this.isAttested = true;
          this.onAttest = true;
          return;
        }

        this.attestItem = requiredPolicies;
        this.onAttest = true;
        this.isAttested = false;
    },

    getAttestationTooltip(item) {
        if (item.training_policies.length === 0) {
            return "Attestation Not Required";
        }

        for (let i = 0; i < item.training_policies.length; i++) {
            const policy = item.training_policies[i];
            if (policy.required && !policy.attested.attested) {
                return "Click to complete attestation";
            }
        }

        return "Attestation Complete";
    },

    getAttestationStatus(item) {
        if (!item.training_policies || item.training_policies.length === 0) {
            return 3; // No policies
        }

        let hasRequiredPolicyNotAttested = false;
        let hasAttestedPolicy = false;

        for (let i = 0; i < item.training_policies.length; i++) {
            const policy = item.training_policies[i];

            // Flag if the user has already attested to this policy
            if (policy.attested && policy.attested.attested) {
                hasAttestedPolicy = true;
            }

            // Flag if there is a required policy that still needs attention
            if (policy.required && (!policy.attested || !policy.attested.attested)) {
                hasRequiredPolicyNotAttested = true;
            }
        }

        if (hasRequiredPolicyNotAttested) {
            return 2; // Required and not attested (Pending / Yellow)
        } else if (hasAttestedPolicy) {
            return 1; // At least one attested and no pending required ones (Complete / Green)
        } else {
            return 3; // No required policies and none attested (Inactive / Gray)
        }
    },

    async attestConfirmation(value) {
      try {
        for (const element of value.data) {
          const data = {
            training_video_id: element.training_videos[0].ID,
            link: element.link,
            date_attested: moment().utc(),
            attested: true,
            training_policy_id: element.ID,
            version: element.version
          };

          const response = await this.$axios.post("/trainings/users/" + this.$store.state.auth.jwtPayload.user_id + "/attest-policy", data);

          if (!response.data.success)
            this.$toast.error(response.data.message);
        }

        this.$toast.success("Successfully attested policy.");
        this.getData();
      } catch (error) {
        // Handle errors if any request fails
        console.error("Error:", error);
      }
    },

    getButtonClass(policy) {
      let status = this.getAttestationStatus(policy)
      switch (status) {
        case 1:
          return 'btn-circle-active';
        case 2:
          return 'btn-circle-pending';
        default:
          return 'btn-circle-inactive';
      }
    },

    getSvgStrokeColor(policy) {
      let status = this.getAttestationStatus(policy)
      switch (status) {
        case 1:
          return '#00B972';
        case 2:
          return '#FFC107';
        default:
          return '#bebebe';
      }
    },

    closeConfirmation() {
      this.attestItem = null;
      this.onAttest = false;
    },
  },

  watch: {
    search: debounce(function() {
      this.completedTrainings = []
      this.getData()
    }, 600),

    sortBy(){
      this.getData();
    }
  }

}
</script>


<style scoped>
.form-control{
  -webkit-border-radius: 0px;
     -moz-border-radius: 20px;
          border-radius: 20px;
}
.btn-create {
  -webkit-border-radius: 20px;
     -moz-border-radius: 20px;
          border-radius: 20px;
  font-size:13px;
  font-weight: 900;
  padding-right: 15px;
  padding-left: 15px;
  margin-bottom: 0px;
}

.btn-square {
  -webkit-border-radius: 0px;
     -moz-border-radius: 0px;
          border-radius: 0px;
  border:1px solid #00A0C1;
}

::-webkit-input-placeholder {
   font-size: 14px!important;
}

:-moz-placeholder { /* Firefox 18- */
      font-size: 14px!important;
}
::-moz-placeholder {  /* Firefox 19+ */
      font-size: 14px!important;
}


.text-default{
	color: #435666;
}

/* Container holding the image and the text */
.container {
  position: relative;
  text-align: center;
  color: white;
}

/* Bottom right text */
.bottom {
  background:#000000;
  position: absolute;
  bottom: 0px;
  width:100%;
  height:25%;
  font-size:14px;
  overflow:visible;
}

.svg-score {
 width: 8%;
 height: 8%;
}


.custom-icon-btn {
  align-items: center;
  justify-content: center;
  padding: 0;
  border-radius: 50%;
}

.custom-icon-btn svg {
  width: 18px;
  height: 18px;
}

.btn-circle-inactive{
  color: #bebebe;
  width: 30px;
	height: 30px;
	padding: 6px 0px;
	border-radius: 15px;
	text-align: center;
	font-size: 12px;
	line-height: 1.42857;
	border: 1px solid #bebebe;
}

.btn-circle-active{
  color: #00B972;
  width: 30px;
	height: 30px;
	padding: 6px 0px;
	border-radius: 15px;
	text-align: center;
	font-size: 12px;
	line-height: 1.42857;
	border: 1px solid #00B972;
}
.btn-circle-pending{
  color: #ffc107;
  width: 30px;
	height: 30px;
	padding: 6px 0px;
	border-radius: 15px;
	text-align: center;
	font-size: 12px;
	line-height: 1.42857;
	border: 1px solid #ffc107;
}

.btn-default.custom-icon-btn:disabled {
  background-color:white;
  color: #435666;
}

.completed-thumbnail {
  width: 100%;
  aspect-ratio: 16 / 9; /* Forces a perfect widescreen rectangle */
  object-fit: cover; /* Zooms/crops the image to fit without squishing it */
  display: block;
}

.bg-theme {
  background-color: #00a0c1 !important;
}

</style>